import { render } from "./HoldetsDonationer.vue?vue&type=template&id=d934d3a0"
import script from "./HoldetsDonationer.vue?vue&type=script&lang=js"
export * from "./HoldetsDonationer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__